import { BobFreshFoodLegInfo } from "./BobFreshFoodLegInfo";
import { BobFreshFoodFields } from "./BobFreshFoodFields";

export class BobFreshFood {
    Leg?: BobFreshFoodLegInfo = undefined;
    Entries?: BobFreshFoodFields[] = undefined;
}